module.exports = __webpack_public_path__ + "img/machine_top.598ef318.jpg";